import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'taskName', standalone: true })
export class TaskNamePipe implements PipeTransform {
    transform(name: string, subtitle?: string): string {
        return subtitle ? `${name}: ${subtitle}` : name;
    }
}
